require('./accountChequebookMovementsHeader.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { formatText } = require('core/i18n').i18n;
const OKSelect = require('components/commons/OKSelect/OKSelect');
// @ constants
const {
    CHEQUEBOOK_FILTER_PAYED_RETURNED_COMPOSED,
    CHEQUEBOOK_FILTER_PAYED,
    CHEQUEBOOK_FILTER_IRREGULAR,
    CHEQUEBOOK_FILTER_COMPOSED,
    CHEQUEBOOK_FILTER_RETURNED
} = require('constants/index');

class AccountChequebookMovementsHeader extends React.Component {
    constructor(props){
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    getSelectionOptions() {
        const options = [
            CHEQUEBOOK_FILTER_PAYED_RETURNED_COMPOSED,
            CHEQUEBOOK_FILTER_PAYED,
            CHEQUEBOOK_FILTER_RETURNED,
            CHEQUEBOOK_FILTER_IRREGULAR,
            CHEQUEBOOK_FILTER_COMPOSED
        ];

        return options.map( (id) => {
            const label = formatText(`accountCheques-${id}`);

            return {
                label,
                value: id
            }
        });
    }

    render() {
        const { onFilterSelect, chequebookFilter } = this.props;
        const title = formatText('accountCheques-cheques');

        return (
            <div className="account-chequebook-movements-header">
                <span className="account-chequebook-movements-header__title">{title}</span>
                <div className="account-chequebook-movements-header__dropdown">
                    <OKSelect
                        name="account-chequebook-movements-header-dropdown"
                        onChange={onFilterSelect}
                        value={chequebookFilter}
                        options={this.getSelectionOptions()}
                        searchable={false}
                        clearable={false}
                    />
                </div>
            </div>
        )
    }
}

AccountChequebookMovementsHeader.propTypes = {
    onFilterSelect: PropTypes.func,
    chequebookFilter: PropTypes.string.isRequired
}

module.exports = AccountChequebookMovementsHeader;
